import { Scope } from '@/domain/external-invitation/entities/external-invitation.entity';
import { InviteCategory } from '@/domain/external-invitation/entities/invitation-category';
import { Sector } from '@/domain/impact/impact.entity';

import { SCOPES } from './data/scopes';
import { Mode } from './scopes-types';

export function getScopeFromModeSectorAndCategory(
  mode: Mode,
  sector: Sector,
  category: InviteCategory,
): Scope {
  const scope = SCOPES[mode][sector][category];
  if (!scope)
    throw `Scope not found for sector and category: ${mode}, ${sector}, ${category}`;
  return scope;
}
